import { ReactNode } from "react";
import { Tooltip } from "antd";
import { MdCheckCircle, MdError, MdWarning } from "react-icons/md";
import { BsCircleFill } from "react-icons/bs";
import styled from "styled-components";
import { gray400, green700, red100, yellow400 } from "core/resources/theme/colors";
import { RdoStatus, RdoStatusEnum } from "./rdoOperacoes.types";

type Props = {
  status: RdoStatus;
};

/** Tips alinhados ao enum BE + protótipo (FE só mapeia; não calcula status). */
export const RDO_STATUS_TIPS: Record<RdoStatus, string> = {
  [RdoStatusEnum.NaoIniciada]:
    "Não iniciada: execução = 0%. Status de prazo não é calculado.",
  [RdoStatusEnum.EmDia]:
    "Em dia: previsão de encerramento ≤ data fim do plano. Só para classes em andamento (0% < execução < 100%).",
  [RdoStatusEnum.EmAtencao]:
    "Em atenção: previsão de encerramento ≥ data fim do plano. Só para classes em andamento (0% < execução < 100%).",
  [RdoStatusEnum.Atrasada]:
    "Atrasada: data fim do plano já chegou ou passou e a operação ainda está em andamento.",
  [RdoStatusEnum.Concluida]:
    "Concluída: execução = 100%. Status de prazo não é calculado para classes fora de andamento.",
};

function RdoStatusCell({ status }: Props) {
  const tip = RDO_STATUS_TIPS[status] || RDO_STATUS_TIPS[RdoStatusEnum.NaoIniciada];

  let icon: ReactNode;
  switch (status) {
    case RdoStatusEnum.EmDia:
    case RdoStatusEnum.Concluida:
      icon = <MdCheckCircle size={18} color={green700} />;
      break;
    case RdoStatusEnum.EmAtencao:
      icon = <MdWarning size={18} color={yellow400} />;
      break;
    case RdoStatusEnum.Atrasada:
      icon = <MdError size={18} color={red100} />;
      break;
    default:
      icon = <BsCircleFill size={12} color={gray400} />;
  }

  return (
    <Tooltip title={tip}>
      <IconWrap aria-label={tip}>{icon}</IconWrap>
    </Tooltip>
  );
}

export default RdoStatusCell;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
`;
